import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Menu, } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CategorySubMenu from './CategorySubMenu';
const CategoryMenu = ({ category, editData }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const menuId = `category-menu-${category.id}`;
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { id: `menu-button-${category.id}`, "aria-controls": open ? menuId : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, endIcon: _jsx(KeyboardArrowDownIcon, {}), className: "pagemenu-button", sx: {
                    letterSpacing: 'normal',
                    justifyContent: { xs: 'space-between', sm: 'start' },
                    p: { xs: '6px 15px' },
                }, children: category.name }), _jsx(Menu, { id: menuId, anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                }, children: category.subCategories.map((subCat) => (_jsx(CategorySubMenu, { category: subCat, closeMenu: handleClose, editData: editData, open: open }, subCat.id))) })] }));
};
export default CategoryMenu;
//# sourceMappingURL=CategoryMenu.js.map